module.exports = __webpack_public_path__ + "static/a-soldier-of-the-great-war-3e6bfcbeff17bcb64617d0708bc921ae.jpg";